import React, { Component } from 'react';
import PropTypes from "prop-types";
import classNames from 'classnames';
import {translate} from "react-i18next";
import Moment from 'react-moment';
import {TIME_FORMAT_ORDER} from '../../constants';


class OrderHistoryView extends Component {

  checkErrorForDisabled(obj) {
    return obj.error ? (obj.error['restaurant'] || obj.error['all_products']) : false;
  }

  reorderOrder(event, data) {
    event.preventDefault();
    if (this.checkErrorForDisabled(data)) {
      return;
    }
    this.props.reorderOrder(data);
  }

  getNameOfOrder(data, language) {
    let result = '';
    data.forEach(obj => {
      result += obj.quantity + ' x ' + obj.product[`name_${language}`] + ' + '
    });
    return result.substring(0, result.length - 3);
  }

  render() {
    const {data, t, language} = this.props;
    return (
      <div className="reorder-list reorder-list--floating">
        {!data.length &&
          <div>{t('orders_not_found')}</div>
        }
        {data.map((obj, index) => (
          <div key={index} className={
            classNames('reorder-list__item', {
              'reorder-list__item--disabled': this.checkErrorForDisabled(obj)
            })}
               onClick={(e) => this.reorderOrder(e, obj)}
          >
            <div className="reorder-list__row">
              <div className="reorder-list__date">
                <Moment format={TIME_FORMAT_ORDER}>{obj.datetime}</Moment>
              </div>
              <div className="reorder-list__location">{obj.restaurant.name}</div>
              {obj.error && obj.error['restaurant'] &&
              <div className="reorder-list__status">{t('restaurant_closed')}</div>
              }
            </div>
            <div className="reorder-list__row">
              <div className="reorder-list__name">
                {this.getNameOfOrder(obj.detail, language)}
              </div>
              <div className="reorder-list__price">{obj.amount}EUR</div>
            </div>
            {obj.error && obj.error['products'] &&
            <div className="reorder-list__message reorder-list__message--alert">
              {t('some_products')}
            </div>
            }
            {obj.error && obj.error['all_products'] &&
            <div className="reorder-list__message reorder-list__message--warning">
              {t('all_products')}
            </div>
            }
            {obj.error && obj.error['price'] &&
            <div className="reorder-list__message reorder-list__message--alert">
              {t('changed_price')}
            </div>
            }
          </div>
        ))}
      </div>
    );
  }
}

OrderHistoryView.propTypes = {
  data: PropTypes.array,
  reorderOrder: PropTypes.func,
  language: PropTypes.string
};


export default translate('translations')(OrderHistoryView);



// WEBPACK FOOTER //
// ./src/components/Customer/OrderHistoryView.js